module.exports = __webpack_public_path__ + "img/tbq-skoler.902721db.webp";